import React from 'react';
import { Main } from '@vwfs-bronson/bronson-react';
import { ToastContainer } from 'react-toastify';

import { ScrollToTopOnNavigation } from '../router/ScrollToTopOnNavigation';
import Footer from './components/Footer/Footer';
import HeaderPrivate from './components/Header/HeaderContainerPrivate';

const MasterPage: React.FunctionComponent = ({ children }) => {
  return (
    <>
      <ToastContainer
        position={'top-right'}
        pauseOnHover={true}
        hideProgressBar={true}
        autoClose={6000}
      />
      <ScrollToTopOnNavigation>
        <div className="o-root">
          <HeaderPrivate />
          <Main>
            {children}
          </Main>
          <Footer />
        </div>
      </ScrollToTopOnNavigation>
    </>
  );
};

export default MasterPage;
